let inputs = document.querySelectorAll(".field .input");
let showHide = document.querySelectorAll(".field .pass_show_hide_wrap");
console.log(inputs);

inputs.forEach((input) => {
  input.addEventListener("input", (e) => {
    if (e.target.value.length > 0) {
      input.classList.add("typing");
    } else {
      input.classList.remove("typing");
    }
  });
});
showHide.forEach(eyed =>{
eyed.addEventListener("click", function () {
  this.classList.toggle("show");
  let targetedInput = this.closest(".input")
    ? this.closest(".input")
    : this.parentElement.firstElementChild;
  if (this.classList.contains("show")) {
    targetedInput.type = "text";
  } else {
    targetedInput.type = "password";
  }
});
})

//---------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const recoverBtn = document.querySelector(".custom_recover_btn");
  if (recoverBtn) {
    recoverBtn.addEventListener("click", function () {
      document
        .querySelector(".recover_pass_wrapper")
        .classList.add("forgotInput");
      document
        .querySelector(".main_login_wrapper")
        .classList.add("removeInput");
    });
  }

  const cancelBtn = document.querySelector(".cancel_login");
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function () {
      document
        .querySelector(".recover_pass_wrapper")
        .classList.remove("forgotInput");
      document
        .querySelector(".main_login_wrapper")
        .classList.remove("removeInput");
    });
  }
});
